import { render } from "@/components/pages/immobilizer/imbDeleteAllKeys/IMBDeleteAllKeys.html?vue&type=template&id=81f6bc88&external"
import script from "@/components/pages/immobilizer/imbDeleteAllKeys/IMBDeleteAllKeys.js?vue&type=script&lang=js&external"
export * from "@/components/pages/immobilizer/imbDeleteAllKeys/IMBDeleteAllKeys.js?vue&type=script&lang=js&external"

import "@/components/pages/immobilizer/imbDeleteAllKeys/IMBDeleteAllKeys.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__